var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustCenterCyan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2 L21 5.5 V11 C21 16.5 17.5 20.5 12 22.5 C6.5 20.5 3 16.5 3 11 V5.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustCenterCyan);
export default __webpack_public_path__ + "static/media/trust-center-cyan.5363eda53cbe5086aa33c4f54fd49868.svg";
export { ForwardRef as ReactComponent };